﻿export default class VerifyEmailLink {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }

    init() {
        this.submitEmailVerifyLink();
    }

    submitEmailVerifyLink() {
        var that = this;
        var email = that.getParameterValues('email');
        var activationCode = that.getParameterValues('ActivationCode');

        var emailActivationCode = {
            "email": email,
            "activationCode": activationCode
        };

        getAjaxData("/api/sitecore/EmailVerification/SubmitEmailVerifyLink", "POST", true, emailActivationCode, function (data) {
            if (data) {
                if (data.success == true) {
                    $(".email-verify-success-message").show();
                    $(".email-verify-failed-message").hide();

                    if (($('html').attr('lang') == 'ro') && data.loginURL != null) {
                        $(".submit-verify-email-link").attr('href', data.loginURL);
                    }
                }
                else {
                    $(".email-verify-success-message").hide();

                    if (data.ErrorCode == 'EMAIL_ACTIVATION_LINK_EXPIRED') {
                        $('#submit-email-verify-failed').html(data.ErrorMessage);
                    }
                    $(".email-verify-failed-message").show();
                }
            }
        });

    }

    getParameterValues(name) {
        var finalResult = '';
        if ($('html').attr('lang') == 'ro') {
            var searchParams = new URLSearchParams(location.search);
            var lowercaseParams = new URLSearchParams();
            for (var [key, value] of searchParams) {
                lowercaseParams.set(key.toLowerCase(), value);
                if (key.toLowerCase() == name.toLowerCase())
                    break;
            }
            finalResult = lowercaseParams.get(name.toLowerCase());
            return finalResult.replace(/ /g, '+');
        }
        else {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            if (results == null) { //stop returning NULL
                finalResult = '';
            } else {
                if (name == 'email') {
                    finalResult = results[0].replace('?email=', '');
                }
                else {
                    finalResult = results[1];
                }
            }
            return finalResult;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new VerifyEmailLink());
